import { render } from "./HeaderBlock.vue?vue&type=template&id=1603fb74&scoped=true"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"

import "./HeaderBlock.vue?vue&type=style&index=0&id=1603fb74&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1603fb74"]])

export default __exports__